import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Play } from "lucide-react";
import { HIGHLIGHTS } from "@/data/content";
import { Kicker, Reveal } from "./Reveal";

const Card = ({ v, i }) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-3%", "3%"]);
  return (
    <Reveal delay={i * 0.1}>
      <a
        ref={ref}
        href={v.href}
        target="_blank"
        rel="noopener noreferrer"
        data-testid={`destaque-card-${v.key}`}
        className="group block"
      >
        <div className="sticker relative aspect-video overflow-hidden rounded-[1.75rem] bg-[var(--ink)]">
          <motion.img
            src={v.img}
            alt={v.title}
            loading="lazy"
            style={{ y, scale: 1.06 }}
            className="absolute inset-0 h-full w-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/45 via-transparent to-transparent transition-opacity duration-500 group-hover:opacity-70" />
          <span className="absolute left-1/2 top-1/2 grid h-14 w-14 -translate-x-1/2 -translate-y-1/2 scale-90 place-items-center rounded-full bg-white/95 shadow-xl transition-transform duration-500 group-hover:scale-110 sm:h-16 sm:w-16">
            <Play className="ml-1 h-6 w-6 sm:h-7 sm:w-7" style={{ color: v.tint, fill: v.tint }} />
          </span>
        </div>
        <h3 className="font-display mt-4 text-xl font-extrabold leading-tight text-[var(--ink)] transition-colors duration-300 group-hover:text-[var(--blue)] sm:text-2xl">
          {v.title}
        </h3>
      </a>
    </Reveal>
  );
};

const Group = ({ g }) => (
  <div data-testid={`destaques-grupo-${g.key}`}>
    <Reveal className="mb-6 flex flex-wrap items-end justify-between gap-3">
      <h3 className="font-display text-3xl font-extrabold text-[var(--ink)] sm:text-4xl">
        <span className={`puffy ${g.puffy}`}>{g.label}</span>
      </h3>
      <span className="font-mono text-xs uppercase tracking-widest text-[var(--ink)]/60">{g.channel}</span>
    </Reveal>
    <div className="grid gap-6 sm:grid-cols-2 md:grid-cols-3 md:gap-8">
      {g.videos.map((v, i) => (
        <Card key={v.key} v={v} i={i} />
      ))}
    </div>
  </div>
);

export const Highlights = () => (
  <section id="destaques" className="px-5 py-24 sm:px-8 sm:py-32" data-testid="destaques-videos-section">
    <div className="mx-auto max-w-6xl">
      <Reveal className="mb-14">
        <Kicker className="text-[var(--ink)]/70">Nossos destaques</Kicker>
        <h2 className="font-display mt-3 text-5xl font-extrabold leading-[0.95] text-[var(--ink)] sm:text-6xl">
          Os vídeos que a <span className="puffy puffy-red">criançada</span> mais ama.
        </h2>
      </Reveal>
      <div className="space-y-20">
        {HIGHLIGHTS.map((g) => (
          <Group key={g.key} g={g} />
        ))}
      </div>
    </div>
  </section>
);
